var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"disabled":_vm.disabled,"dense":_vm.dense,"items":_vm.listOfGenders,"hide-details":_vm.hideDetails,"placeholder":"Gender"},model:{value:(_vm.chosenGender),callback:function ($$v) {_vm.chosenGender=$$v},expression:"chosenGender"}})
}
var staticRenderFns = []

export { render, staticRenderFns }